import * as LR from "@uploadcare/blocks";
LR.registerBlocks(LR);

(() => {
  const providerNode = document.getElementById("my-uploader-provider");
  const previewsNode = document.getElementById("previews");
  const input = document.getElementById("uploader-input");
  const dimensions = input?.dataset.dimensions;

  if (!providerNode || !previewsNode || !input) {
    return;
  }

  providerNode.addEventListener("change", (event) => {
    renderFiles(
      event.detail.allEntries.filter((file) => file.status === "success"),
    );
  });

  function renderFiles(files) {
    const renderedFiles = files.map((file) => {
      const imgNode = document.createElement("img");
      const fileName = `${file.cdnUrl}-/scale_crop/${dimensions}/center/-/format/auto/-/quality/smart/`;
      imgNode.setAttribute("src", fileName);
      input.value = fileName;
      imgNode.setAttribute("alt", file.fileInfo.originalFilename);

      return imgNode;
    });

    previewsNode.replaceChildren(...renderedFiles);
  }
})();
